module.exports = __webpack_public_path__ + "img/NXS.00978948.svg";